import { Component, Input } from '@angular/core';

import { SvgComponent } from '../svg/svg.component';
@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  imports: [SvgComponent],
})
export class ContactsComponent {
  @Input() phone: string | undefined;

  @Input() email: string | undefined;

  public onLinkClick(event: MouseEvent) {
    event.stopPropagation();
  }
}
